import { render, staticRenderFns } from "./uploadBaseScoreReportSummary.vue?vue&type=template&id=6f4e680b&scoped=true&"
import script from "./uploadBaseScoreReportSummary.vue?vue&type=script&lang=js&"
export * from "./uploadBaseScoreReportSummary.vue?vue&type=script&lang=js&"
import style0 from "./uploadBaseScoreReportSummary.vue?vue&type=style&index=0&id=6f4e680b&lang=stylus&scoped=true&"
import style1 from "./uploadBaseScoreReportSummary.vue?vue&type=style&index=1&id=6f4e680b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4e680b",
  null
  
)

export default component.exports